import React from 'react';
import { Button, Icon } from 'semantic-ui-react';

const DownloadButton = (props) => {
    return (
      <Button compact color='teal' {...props} icon size={ props.caption ? 'small' : 'mini' } loading={props.loading || false} disabled={props.disabled || false} onClick={props.onClick} className={props.className}>
        <Icon name="download" /> {props.caption}
      </Button>
    )
}

export default DownloadButton;
